<template>
  <div class="nav">
    <div class="line flex_row">
      <p class="line_left"></p>
      <p class="line_right"></p>
    </div>

    <div class="nav_logo flex_row">
      <img
        style="width: 262px; height: 54px"
        src="../../assets/qingye/图层111.png"
      />
      <div class="right flex_row animated bounce">
        <img src="../../assets/phone_icon.png" />
        <div class="phone">
          <p style="color: #232323; font-size: 14px">欢迎联系我们</p>
          <p style="font-size: 24px; color: #1b63a7; font-weight: 500">
            0592-5258000
          </p>
        </div>
      </div>
    </div>
    <div class="nav_btn_box flex_row hoverName navClass">
      <div
        :class="$store.state.tabbar == index ? 'btn_li active' : 'btn_li'"
        v-for="(item, index) in navList"
        :key="index"
      >
        <p @click="openNav(index)">{{ item }}</p>
      </div>
      <div class="navClass_about">
        <el-dropdown
          @visible-change="handleChange"
          trigger="click"
          @command="handleCommand"
        >
          <div
            :class="
              this.show == true ? 'navClassActive navClassTextActive' : ''
            "
            class="navClass_about_text"
          >
            关于我们<i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in dropdownList"
              :key="index"
              :command="item.path"
              >{{ item.name }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "navBar",
  data() {
    return {
      Index: 0,
      navList: ["首页", "企业动态", "技术服务", "案例展示", "解决方案"],
      dropdownList: [
        {
          name: "公司简介",
          path: "/Community/CompanyProfile",
          imgSrc: require("../../assets/qingye/Aboutus.png"),
        },
        {
          name: "荣誉资质",
          path: "/Community/HonoraryCertificate",
          imgSrc: require("../../assets/qingye/1102.png"),
        },
        {
          name: "下载中心",
          path: "/Community/DataDownload",
          imgSrc: require("../../assets/qingye/1102.png"),
        },
        {
          name: "联系我们",
          path: "/Community/ContactUs",
          // imgSrc: 'http://127.0.0.1:8080/static/img/Contactus.52d8304.png'
          imgSrc: require("../../assets/qingye/Contactus.png"),
        },
      ],
      pathList: [],
      show: false,
    };
  },
  mounted() {},
  methods: {
    //切换nav
    openNav(index) {
      this.$cookies.set("tabbar", index);
      this.$store.state.tabbar = this.$cookies.get("tabbar");
      if (index == 0) {
        this.$router.push("/");
      }
      if (index == 1) {
        this.$router.push("/ParkOverview");
      }
      if (index == 2) {
        this.$router.push("/service");
      }
      if (index == 3) {
        this.$cookies.set("tab1", 1);
        this.$router.push("/ParkKeeper");
      }
      if (index == 4) {
        this.$router.push("/BusinessCooperation");
      }

      if (index == 6) {
        this.$router.push("/MoreWords");
        // window.location.href = 'https://www.zhipin.com/gongsi/a36191785d5037d11nVy2Nu6EFc~.html?ka=search_rcmd_company_name_a36191785d5037d11nVy2Nu6EFc~_custompage'
      }
    },
    // 获取点击的路径
    handleCommand(command) {
      this.$router.push({
        path: command,
      });
      // console.log(command)
      // this.dropdownList.forEach(item => {
      //   this.pathList.push(item.path)
      // })
      this.$emit("handlePath", command, this.dropdownList);
    },
    // 判断下拉菜单是否打开
    handleChange(isChange) {
      if (isChange == true) {
        this.show = true;
        this.$store.state.tabbar = null;
      } else {
        this.show = false;
      }
    },
  },
};
</script>
<style scoped>
.nav {
  /*max-width: 1920px;*/
  height: 190px;
  margin: 0 auto;
  min-width: 1200px;
  /*background: orange;*/
}
.line {
  height: 7px;
  width: 100%;
}

.line_left {
  height: 7px;
  width: 60%;
  background: #1b63a7;
}

.line_right {
  width: 40%;
  background: #000000;
}

.nav_logo {
  width: 84%;
  margin: 20px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.nav_logo .right {
  align-items: center;
}
.nav_logo .right .phone {
  margin-left: 20px;
}
.nav_logo .right img {
  width: 37px;
  height: 28px;
}

/*.logo_box {*/
/*    width: 405px;*/
/*    height: 70px;*/
/*}*/

/*.logo_box img {*/
/*    width: 100%;*/
/*    height: 100%;*/
/*}*/

.nav_btn_box {
  width: 1200px;
  margin: 0 auto;
  margin-top: 36px;
  /*background: yellowgreen;*/
}

.nav_btn_box .btn_li {
  width: 94px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  /*margin-left: 22px;*/
  margin-right: 22px;
  transform: skew(-15deg);
  color: #333333;
}
.active {
  background: #1b63a7;
  color: white !important;
}

.nav_btn_box .btn_li p {
  transform: skew(15deg);
  font-size: 14px;
}
.hoverName:hover {
  cursor: pointer;
}

.navClass {
  display: flex;
  align-items: center;
}
.navClass_about {
  /*padding-left: 25px;*/
  width: 94px;
  height: 34px;
  margin-left: 22px;
}
.navClass_about_text {
  font-size: 14px;
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 34px;
  color: #333333;
}
.navClassActive {
  width: 94px;
  height: 34px;
  line-height: 34px;
  background: #1b63a7;
  transform: skew(-15deg);
  color: white;
  text-align: center;
}
.navClassTextActive {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/components/navBar.vue